import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import { parts } from '../../../utilities/parts';

import AnamnesesApi from '../../../services/workers/anamneses/AnamnesesApi';
import AnamnesesService from '../../../services/workers/anamneses/AnamnesesService';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { WorkerHeader } from '../header/WorkerHeader';
import AnamnesesForm from '../form/AnamnesesForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';
import ConfirmationSafetyDocItemDialog from '../dialog/ConfirmationSafetyDocItemDialog';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { validationByJoi } from '../../../utilities/commonValidation';
import { extractErrorMessage } from '../../../utilities/commonUtil';
import { deleteControlCode } from '../../../utilities/stringUtil';

import {
  WORKER_TAB,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  SAFETY_DOC_ITEM_VALIDATE,
  EXISTANCE_FLAG,
} from '../../../utilities/constants';

/**
 * 既往症ページ
 * @props {string}companyId:会社ID
 * @props {string}workerId:作業員ID
 * @props {object}pageStatus:ページ情報 (新規・詳細・編集)
 * @props {Boolean}isAlreadyCcusConnect:CCUSと連携しているか？
 * @props {Boolean}isAgencyRegister:代理ログインか？
 * @props {string}linkedToCcusDate:CCUSと連携した時間
 * @props {function}callFetchCcusWorkersData:CCUS情報取得処理
 */
export class Anamneses extends React.Component {
  defaultAnamneses = {
    anamnesis_type: null, // 既往症有無
    anamnesis_detail_type_high_blood_pressure: null, // 高血圧
    anamnesis_detail_type_low_blood_pressure: null, // 低血圧
    anamnesis_detail_type_angina_pectoris: null, // 狭心症
    anamnesis_detail_type_diabetes: null, // 糖尿病
    anamnesis_detail_type_hearing_loss: null, // 難聴
    anamnesis_detail_type_night_blindness: null, // 夜盲症
    anamnesis_detail_type_whiplash_syndrome: null, // 馬鞭式創傷綜合症
    anamnesis_detail_type_lumbago: null, // 腰痛
    anamnesis_detail_type_heatstroke: null, // 熱中症
    anamnesis_etc: null, // その他
  };

  state = {
    header: {
      // 作業員基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    confirmationModalSafetyDocItem: {
      // 安全書類項目用バリデート
      errorPropertyList: [],
    },
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    validErrorMessage: {}, // バリデーションエラーメッセージ
    anamneses: { ...this.defaultAnamneses },
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = true; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT
      )
    ) {
      throw new Error('Anamneses.jsx constructor props.pageStatus');
    }
    if (_.isUndefined(props.workerId)) {
      throw new Error('Anamneses.jsx constructor props.workerId');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('Anamneses.jsx constructor props.companyId');
    }

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
    this.state.roanToChoseiFlg = props.roanToChoseiFlg;

    // AnamnesesForm.jsxに渡すイベント
    this.events.setValueAnamneses = this.setValueAnamneses.bind(this);
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    const state = _.cloneDeep(this.state);

    // 労務安全項目情報（既往症）を取得する
    await AnamnesesApi.fetchAnamneses(
      this.props.companyId,
      this.props.workerId
    ).then(response => {
      if (response.result) {
        state.anamneses = response.data.entities.worker_anamneses;
        // 2020年5月現在、既往症についてはCCUSから情報を取得していないためコメントアウト
        // state.ccus_info: response.data.entities.ccus_worker_anamneses,
      } else {
        alert(response.message);
      }
    });

    this.setState(state, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
    });
  }

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerUpdate.bind(this);
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }    
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.ANAMNESES.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * 編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }    
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.ANAMNESES.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 更新を実行する前に実行する処理
   * 要入力ダイアログ表示
   */
  handlerUpdate() {
    const resultValidate = this.validateAllSafetyDocItem();
    // console.log('Anamneses.jsx handlerUpdate', resultValidate);
    if (resultValidate.status === true) {
      this.updateAnamneses();
      return;
    }

    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id;
    state.confirmationModalSafetyDocItem.errorPropertyList = [];
    for (let key of Object.keys(resultValidate.messages)) {
      const constName = Object.values(SAFETY_DOC_ITEM_VALIDATE.ANAMNESES).find(
        constValue => constValue.KEY === key
      );
      if (!_.isUndefined(constName)) {
        state.confirmationModalSafetyDocItem.errorPropertyList.push(
          constName.TEXT
        );
      } else {
        throw new Error('Anamneses.jsx handlerUpdate message property');
      }
    }
    this.setState(state);
  }

  /**
   * 既往症更新
   */
  updateAnamneses() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = _.cloneDeep(this.state);
    const params = AnamnesesService.createUpdateAnamnesesParam(state.anamneses);
    AnamnesesApi.updateAnamneses(
      this.props.companyId,
      this.props.workerId,
      params
    )
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          this.moveToWorkerConfirm();
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(response);
        this.updatingFlag = false;
        this.setState(state);
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.updatingFlag = false;
        this.setState(state);
      });
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 安全書類項目用バリデーション(要入力)
   */
  validateAllSafetyDocItem = () => {
    const anamneses = _.cloneDeep(this.state.anamneses);
    const schema = AnamnesesService.createValidateSchemaSafetyDocItem();

    const result = validationByJoi(Joi.object().keys(schema), anamneses);
    // console.log(
    //   'Anamneses.jsx validateAllSafetyDocItem',
    //   anamneses,
    //   result
    // );

    if (!parts.inProperty(result, 'messages,status')) {
      throw new Error('Anamneses.jsx validateAllSafetyDocItem');
    }
    if (!_.isObject(result.messages)) {
      throw new Error('Anamneses.jsx validateAllSafetyDocItem');
    }
    return result;
  };

  /**
   * 既往症の情報をセット
   * @param {string} name：セット対象のキー名
   * @param {string} value：セットするデータ
   */
  setValueAnamneses = (name, value) => {
    const state = _.cloneDeep(this.state);
    value = deleteControlCode(value);
    state.anamneses[name] = value;

    if (name === 'anamnesis_type') {
      if (value === EXISTANCE_FLAG.NOEXIST.VALUE) {
        // 既往症有無の有→無への変更時に
        // 他項目の選択を解除する
        const setAnamneses = { ...this.defaultAnamneses };
        delete setAnamneses.anamnesis_type;
        state.anamneses = { ...state.anamneses, ...setAnamneses };
      }
    }

    this.setState(state);
  };

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={0}
        />
        <div className='contruction-detail-view__bar' />

        <AnamnesesForm
          events={this.events}
          messages={this.state.validErrorMessage}
          formValues={this.state.anamneses}
          disabledAll={this.props.pageStatus.DISABLED_ALL}
          comboBoxList={this.state.comboBoxList}
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.closeDialog()}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />

        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id }, () => {
              this.updateAnamneses();
            });
          }}
          onCancel={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/worker/page/Anamneses.jsx